import { render, staticRenderFns } from "./CreateProspect.vue?vue&type=template&id=06717e0a&"
import script from "./CreateProspect.vue?vue&type=script&lang=js&"
export * from "./CreateProspect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports